export default function Section19() {
    return (
        <div className="w-full py-[30px] md:py-[60px] bg-[#f9f9f9] text-center SectionCTA">
            {/* Heading */}
            <h2 className="text-[26px] md:text-[30px] font-bold text-[#151515] leading-[32px] md:leading-[41px] mb-4">
                Let’s Turn Your Website Traffic into Conversions
            </h2>

            {/* Subheading */}
            <p className="text-[#555] text-[16px] md:text-[18px] max-w-[650px] mx-auto">
                Your website already attracts visitors. Let Mean3 help you turn them into loyal customers. Our CRO experts in Dubai and across the UAE are ready to analyze your site and create a strategy that drives real growth.
            </p>
        </div>
    );
}
